// translation filter
finderApp.filter('translate', ['$sce', function ($sce) {
    return function (text, trust) {
        if (typeof text != "string") {
            return text;
        }

        return trust ? $sce.trustAsHtml(Util.i18n.get(text)) : Util.i18n.get(text);
    };

}]);